class PaymentTimer {
	constructor() {
		this.container = document.getElementById('payment-timer');
		this.display = this.container.querySelector('.payment-timer__display');
		this.expireTime = parseInt(this.container.dataset.expire) * 1000;
		this.timerId = null;
		this.isExpired = false;

		this.init();
	}

	init() {
		this.update();
		this.timerId = setInterval(() => this.update(), 1000);
	}

	update() {
		const now = Date.now();
		const diff = this.expireTime - now;

		if (diff <= 0) {
			this.stop();
			this.display.textContent = '00:00';
			this.triggerExpire();
			return;
		}

		this.render(diff);
	}

	render(ms) {
		const totalSeconds = Math.floor(ms / 1000);
		const hours = Math.floor(totalSeconds / 3600);
		const minutes = Math.floor((totalSeconds % 3600) / 60);
		const seconds = totalSeconds % 60;

		const h = String(hours).padStart(2, '0');
		const m = String(minutes).padStart(2, '0');
		const s = String(seconds).padStart(2, '0');

		this.display.textContent = hours > 0 ? `${h}:${m}:${s}` : `${m}:${s}`;
	}

	stop() {
		if (this.timerId) clearInterval(this.timerId);
	}

	triggerExpire() {
		this.isExpired = true;
		const event = new CustomEvent('paymentExpired', {
			detail: { expiredAt: this.expireTime },
		});
		this.container.dispatchEvent(event);
	}
}

export default PaymentTimer;
